import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";
import { Home, Pricing, HowItWorks, StateLaws, StatePage, Resources, InfoPage, StatePrenupVsPostnup, PrenupCost } from "@/components/Marketing";
import PrenupCheck from "@/pages/PrenupCheck";
import { Login, Register, AuthCallback } from "@/pages/Auth";
import { Terms, Privacy, Editorial, About, Contact, BillingPolicy, CreditsPolicy } from "@/pages/LegalPages";
import { LearnHub, ClauseLibrary, AlimonyGuide, PrenupVsPostnup, PostnupGuide, UPMAAGuide, LearnFAQ } from "@/pages/Learn";
import Dashboard from "@/pages/Dashboard";
import Billing from "@/pages/Billing";
import Workspace from "@/pages/Workspace";
import Admin from "@/pages/Admin";
import Review from "@/pages/Review";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/state-laws" element={<StateLaws />} />
            <Route path="/enforceability-check" element={<PrenupCheck />} />
            <Route path="/prenup-check" element={<PrenupCheck />} />
            <Route path="/prenup-vs-postnup/:state" element={<StatePrenupVsPostnup />} />
            <Route path="/prenup-cost/:state" element={<PrenupCost />} />
            <Route path="/state-laws/:state" element={<StatePage kind="state-laws" />} />
            <Route path="/prenup" element={<InfoPage slug="prenup" />} />
            <Route path="/prenup/:state" element={<StatePage kind="prenup" />} />
            <Route path="/postnup" element={<InfoPage slug="postnup" />} />
            <Route path="/postnup/:state" element={<StatePage kind="postnup" />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/resources/:slug" element={<InfoPage />} />
            <Route path="/learn" element={<LearnHub />} />
            <Route path="/learn/clauses" element={<ClauseLibrary />} />
            <Route path="/learn/alimony" element={<AlimonyGuide />} />
            <Route path="/learn/prenup-vs-postnup" element={<PrenupVsPostnup />} />
            <Route path="/learn/postnup" element={<PostnupGuide />} />
            <Route path="/learn/upmaa" element={<UPMAAGuide />} />
            <Route path="/learn/faq" element={<LearnFAQ />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/editorial" element={<Editorial />} />
            <Route path="/billing-policy" element={<BillingPolicy />} />
            <Route path="/credits-policy" element={<CreditsPolicy />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/billing" element={<Billing />} />
            <Route path="/workspace/:id" element={<Workspace />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/review/:token" element={<Review />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
export default App;
